ike-navbar {
  header {
    background-color: $white;
    background-color: var(--white);

    border-bottom: 1px solid $gray-extra-light;
    border-bottom: 1px solid var(--gray-extra-light);

    .menu-container-desktop {
      margin: auto;
      display: flex;
      width: 100%;
      max-width: calc(1120px + 2 * 40px);
      height: 120px;
      justify-content: space-between;
      justify-self: center;
      align-items: center;
      padding: 35px 40px;
      z-index: 1000;
      position: relative;

      .MD & {
        padding: 20px;
        height: 70px;
      }
    }

    .EMBEDED & {
      background: transparent;
      border-bottom: none;
    }
    .MD & {
      .avatar {
        display: none;
      }
    }

    .responsive > .actions-links {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
    }


    .currencies, .languages {
      text-transform: uppercase;
      .trigger{
        white-space: nowrap;
      }
      .icon-chevron-down {
        font-size: 12px;
        margin-left: 7px;
      }
    }

    .wrap {
      max-width: 1400px;
      padding: 0 35px;
      align-items: center;
      display: flex;
      justify-content: space-between;

      .EMBEDED & {
        max-width: 1140px;
        display: none;
      }
    }

    h1 {
      max-width: 410px;
    }

    .period-name {
      > div {
        align-items: center;
        display: inline-flex;
      }

      .button{
        margin-left: 10px;
        text-align: left;
      }

      .MD & {
        > div {
          display: inline-flex;
          align-items: center;
          h1 {
            max-width: 200px;
          }
        }
        margin: auto;
        text-align: center;

        .logo {
          margin-bottom: 10px;
          margin-right: 0;
        }

        a {
          display: block;
        }
      }
    }

    .hamburger {
      cursor: pointer;
      z-index: 12;

      span {
        background-color: $black;
        background-color: var(--black);
        display: block;
        height: 1.5px;
        margin: 4.5px auto;
        transition: all 0.3s ease;
        width: 21px;
      }

      &.active {
        span:first-of-type {
          transform: rotate(-45deg) translateY(4px);
        }

        span:nth-of-type(2){
          display: none;
        }

        span:last-of-type {
          transform: rotate(45deg) translateY(-4px);
        }
      }
    }

    img.logo {
      height: 42px;
      margin-right: 20px;
      width: 86px;
    }

    .cart {
      a {
        position: relative;
      }
    }

    .icon-cart, .icon-single-neutral-circle {
      color: $gray-dark;
      color : var(--gray-dark);
      font-size: 23px;
      height: 23px;
    }

    nav {
      align-items: center;
      display: flex;
      justify-content: space-between;
      max-width: 460px;

      > div, > ike-link, > ike-dropdown {
        margin-left: 30px;
      }

      > ike-avatar {
        height: 23px;
      }

      .button {
        align-items: center;
        display: flex;
      }

      .icon-triangle {
        font-size: 8px;
        margin-left: 5px;
      }
    }

    .content {
      background-color: $white;
      background-color: var(--white);
      bottom: 0;
      left: 0;
      position: fixed;
      right: 0;
      top: 68px;
      overflow: hidden;
      padding: 10px 0 10px 0;
      transform: translateX(-100%);
      transition: transform 0.7s ease;
      z-index: 10;

      &.active {
        transform: translateX(0%);
      }

      .button.btn-cart:hover {
        color: $gray-medium;
        color: var(--gray-medium);
      }

      .wrap {
        justify-content: center;
        flex-direction: column;

        .footer-line {
          margin: 0;
          position: absolute;
          bottom: 40px;

          > p {
            align-items: baseline;
            display: flex;

            a {
              font-size: 20px;
              line-height: 28px;
              margin: 0 0 0 4px;
            }
          }
        }

        > div {
          margin-bottom: 40px;

          div.link-display {
            margin-bottom: 40px;
            cursor: pointer;
          }

          div.link-display:last-of-type {
            margin-bottom: 0;
          }

          i.icon {
            display: block;
            font-size: 28px;
            margin-bottom: 13px;
            color: $main-color;
            color: var(--main-color);
            text-align: center;
          }

          .text-4 {
            color: $gray-medium;
            color: var(--gray-medium);
            text-transform: none;
          }

          a {
            display: block;
            text-align: center;
          }

          .languages,
          .currencies {
            display: flex;
            align-items: center;
            justify-content: center;

            p {
              margin-right: 10px;
            }
          }
        }
      }
    }
  }

  .navbar-responsive {
    display: none;

    .wrap {
      display: flex !important;

      .MD & {
        display: block !important;
      }

      > div {
        display: flex;
        justify-content: inherit;
        width: 90%;
        margin-right: 30px;

        .MD & {
          margin: inherit;
          width: 100%;
        }

        button {
          color: $gray-dark;
          color : var(--gray-dark);
          font-weight: 500;
          font-size: 17px;
          line-height: 18px;
          display: flex;
          align-items: center;
          cursor: pointer;
          margin-left: 0;

          i {
            font-size: 13px;
            margin-left: 15px;
          }
        }
      }

      > ike-link {
        .MD & {
          margin-top: 20px;
          text-align: right;
        }
        i {
          color: $gray-dark;
          color: var(--gray-dark);
        }
      }
    }
  }

  .is-portal &{
    position: sticky;
    top: 0;
    z-index: 999;
    width: 100%;
  }

  .action-buttons {
    display: flex;
    gap: 1rem;
  }
}

.ike-queue-modal{
  text-align: center;
}


.period-list-wrapper {
  align-items: center;
  display: inline-flex;
  justify-content: space-between;
  margin-bottom: 10px;
  width: 100%;
  gap: 20px;

  h1 {
    .SM & {
      font-size: 14px;
    }
  }
  span {
    cursor: pointer;
  }
}

.default-shops-list {
  max-height: 80vh;
  height: 100%;
  overflow-y: auto;
}

@media(max-width: 1200px) {
  ike-navbar {
    header {
      .is-portal &{
        right: 35px;
      }
    }
  }
}

@media(max-width: 768px) {
  ike-navbar {
    header,
    .navbar-responsive {
      .is-portal &{
        right: 20px;
      }
    }
  }
}
